<template>
    <div>
        <span>{{ $t('notification.webTabUpdated', {
            actor: $_.get(activity, 'actorUser.name'),
            tabName: $_.get(activity, 'payload.tabName')
        }) }}</span>
    </div>
</template>

<script>
export default {
    name: "WebTabUpdated",
    props: {
        activity: {
            type: Object,
            required: true
        }
    }
};
</script>


